export const environment = {
  production: false,
  devTools: false,
  api: {
    url: 'https://vc-my-gateway-api.nt-test.dev/api/my',
  },
  authClientId: 'my-client',
  gaMeasurementId: '',
  recaptchaSiteKey: '6LcSKc8ZAAAAAADOH_KzpLSjfnF5-j4f1nJA4xqN',
};
